export const selectTagSearchOptions = (state) => state.tags.tagSearchOptions;